// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles__loader___12lNz","load8":"styles__load8___2POAp"};